module.exports = __webpack_public_path__ + "8a5356e9/img/rename-icon.de4e673d.svg";